import { cva } from 'class-variance-authority'

/**
 * Category Cards CVA Configuration
 *
 * Styles for homepage category card grid with image + title layout
 */

/**
 * Category cards grid container
 */
export const categoryCardsGridVariants = cva('grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6')

/**
 * Individual category card wrapper
 */
export const categoryCardItemVariants = cva([
  'group cursor-pointer overflow-hidden rounded border border-gray-200',
  'hover:shadow-lg transition-all duration-300',
  'bg-white no-underline',
  'text-text-color visited:text-text-color hover:text-text-color active:text-text-color focus:text-text-color',
])

/**
 * Category card image wrapper — uses 5:6 portrait aspect ratio to match the
 * 500×600 admin upload recommendation. Fixed height previously forced a much
 * more vertical ratio on mobile (2-col grid) which made object-cover zoom in.
 */
export const categoryCardImageWrapperVariants = cva('aspect-[5/6] overflow-hidden')

/**
 * Category card image with hover zoom
 */
export const categoryCardImageVariants = cva([
  'w-full h-full object-cover',
  'group-hover:scale-105 transition-transform duration-500',
])

/**
 * Category card title - font-sec-font bold, stable color on all link states
 */
export const categoryCardTitleVariants = cva(
  'text-center py-3 font-bold text-lg md:text-xl font-sec-font text-text-color'
)

/**
 * Category card skeleton wrapper — keeps the same visual footprint as the real
 * card (border + rounded + image aspect-[5/6] + title strip) to prevent layout
 * shift when content arrives.
 */
export const categoryCardSkeletonVariants = cva('overflow-hidden rounded border border-gray-200')
